export default __webpack_public_path__ + "static/media/To Where the Prescript Points.f3152e9e.png";